import type { AxiosError } from 'axios';
import type { ReactNode } from 'react';

type P<T = unknown> = {
  children: ReactNode;
  error?: AxiosError<T> | Error | null;
  fallbackRender: (error: AxiosError<T> | Error | null) => ReactNode;
};

const ErrorHandler = <T = unknown,>({ children, error, fallbackRender }: P<T>): ReactNode => {
  if (error) {
    return fallbackRender(error);
  }

  return children;
};

export default ErrorHandler;
